// src/App.jsx

import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import Cookies from "js-cookie";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import OrderManager from './pages/OrderManager';
import CustomerListing from './pages/CustomerListing';
import EmployeeListing from './pages/EmployeeListing';
import CostumeListing from './pages/CostumeListing';
import BillingScreen from './pages/BillingScreen';
import OrderListing from './pages/OrderListing';
import OrderList from './Newdesign/OrderList';

import EmployeeAdding from "./Newdesign/EmployeeAdding";
import FittingAdding from "./Newdesign/FittingAdding";
import FittingManager from "./Newdesign/FittingManager";
import OrderCreation from "./Newdesign/OrderCreation";
import Login from "./Newdesign/Login";
import DashboardCards from "./Newdesign/DashboardCards";
import DressComponent from "./Newdesign/DressComponent";
import FitDetails from "./Newdesign/FitDetails";
import InsertFittings from "./Newdesign/InsertFittings";
import EditOrder from "./Newdesign/EditOrder";
// Import other pages as you create them
// import BillingScreen from './pages/BillingScreen'; 

function InnerApp() {
  const navigate = useNavigate();
  const location = useLocation();

  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const loginStatus = Cookies.get("tailor_auth_status");

  // Sidebar Tabs
  // Sidebar Tabs
  const tabs = [
    { id: "DashboardCards", label: "Dashboard", path: "/" },
    { id: "OrderCreation", label: "Order Creation", path: "/order-create" },
    { id: "OrderList", label: "Order List ", path: "/orders-list" },
    { id: "fittingManager", label: "Fitting Manager", path: "/fittings" },
    // Use existing clean path for this one
    { id: "OrderListing", label: "Order Listing", path: "/orders" },
    { id: "EmployeeAdding", label: "Employee Adding", path: "/employees" },
    { id: "FittingAdding", label: "Fitting Adding", path: "/fittings/add" },
    // New, clean paths for the legacy pages:
    { id: "OrderManager", label: "Order Manager", path: "/order-manager" },
    { id: "CostumeListing", label: "Costume Listing", path: "/costume-listing" },
    { id: "CustomerListing", label: "Customer Listing", path: "/customer-listing" },
    { id: "EmployeeListing", label: "Employee Listing", path: "/employee-listing" },
    { id: "BillingScreen", label: "Billing Screen", path: "/billing-screen" },
  ];
  // Sync selected sidebar tab with route
  useEffect(() => {
    const found = tabs.find((t) => t.path === location.pathname);
    if (found) {
      setActiveTab(found.id);
    } else if (loginStatus && location.pathname === "/") {
      setActiveTab("DashboardCards");
    }
  }, [location.pathname, loginStatus]);

  // Navigation handler
  const handleNavigate = (tab) => {
    if (!loginStatus) {
      navigate("/login");
      return;
    }

    navigate(tab.path);
    setActiveTab(tab.id);
    setMobileSidebarOpen(false);
  };

  // Login success handler
  const onLoginSuccess = () => {
    navigate("/");
    setActiveTab("DashboardCards");
  };

  // Logout handler
  const handleLogout = () => {
    Cookies.remove("tailor_auth_status");
    navigate("/login");
  };
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      {/* HEADER */}
      <header className="bg-blue-950 text-white shadow-md p-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMobileSidebarOpen(true)}
            className="lg:hidden text-2xl"
          >
            ☰
          </button>
          <h1 className="text-xl font-semibold">Fitting Studio</h1>
        </div>

        <div>
          {loginStatus ? (
            <button
              onClick={handleLogout}
              className="bg-white/10 px-3 py-1 rounded hover:bg-white/20"
            >
              Logout
            </button>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="bg-white/10 px-3 py-1 rounded hover:bg-white/20"
            >
              Login
            </button>
          )}
        </div>
      </header>

      <div className="flex flex-grow">
        {/* MOBILE SIDEBAR */}
        {loginStatus && (
          <>
            {mobileSidebarOpen && (
              <div
                className="fixed inset-0 bg-black bg-opacity-40 z-40 lg:hidden"
                onClick={() => setMobileSidebarOpen(false)}
              >
                <aside
                  className="absolute left-0 top-0 h-full w-64 bg-white shadow-xl rounded-r-2xl p-4"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h2 className="text-blue-950 text-lg font-bold mb-4">Menu</h2>

                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => handleNavigate(tab)}
                      className={`px-4 py-2 mb-2 rounded border text-left w-full ${activeTab === tab.id
                        ? "bg-blue-950 text-white"
                        : "bg-blue-50 text-blue-700 border-blue-200"
                        }`}
                    >
                      {tab.label}
                    </button>
                  ))}

                </aside>
              </div>
            )}

            {/* DESKTOP SIDEBAR */}
            <aside className="hidden lg:block w-64 bg-white shadow-xl border-r border-blue-200 p-4">
              <h2 className="text-blue-950 text-lg font-bold mb-4">Menu</h2>

              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleNavigate(tab)}
                  className={`px-4 py-2 mb-2 rounded border text-left w-full ${activeTab === tab.id
                    ? "bg-blue-950 text-white"
                    : "bg-blue-50 text-blue-700 border-blue-200"
                    }`}
                >
                  {tab.label}

                </button>

              ))}


            </aside>
          </>
        )}

        {/* MAIN ROUTES */}
        <main className="flex-grow p-4 lg:p-6">
          <Routes>
            <Route
              path="/"
              element={loginStatus ? <DashboardCards /> : <Navigate to="/login" />}
            />

            <Route
              path="/order-create"
              element={loginStatus ? <OrderCreation /> : <Navigate to="/login" />}
            />

            <Route
              path="/orders"
              element={loginStatus ? <OrderListing /> : <Navigate to="/login" />}
            />

            <Route
              path="/employees"
              element={loginStatus ? <EmployeeAdding /> : <Navigate to="/login" />}
            />

            {/* EDIT ORDER ROUTE - Fixed to match OrderListing navigation */}
            <Route
              path="/edit-order"
              element={loginStatus ? <EditOrder /> : <Navigate to="/login" />}
            />

            <Route
              path="/fittings/add"
              element={loginStatus ? <FittingAdding /> : <Navigate to="/login" />}
            />

           <Route
              path="/fittings"
              element={loginStatus ? <FittingManager /> : <Navigate to="/login" />}
            />
            <Route
              path="/login"
              element={loginStatus ? <Navigate to="/" /> : <Login onLoginSuccess={onLoginSuccess} />}
            />

            {/* EXTRA ROUTES */}
            <Route
              path="/DressComponent"
              element={loginStatus ? <DressComponent /> : <Navigate to="/login" />}
            />

            <Route
              path="/fit-details/:dressName"
              element={loginStatus ? <FitDetails /> : <Navigate to="/login" />}
            />

            <Route
              path="/InsertFittings"
              element={loginStatus ? <InsertFittings /> : <Navigate to="/login" />}
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to={loginStatus ? "/" : "/login"} />} />

            {/* Implemented Screens (Updated to clean paths) */}
            <Route path="/orders-list" element={<OrderList />} />
            <Route path="/order-manager" element={<OrderManager />} />
            <Route path="/customer-listing" element={<CustomerListing />} />
            <Route path="/employee-listing" element={<EmployeeListing />} />
            <Route path="/costume-listing" element={<CostumeListing />} />
            <Route path="/billing-screen" element={<BillingScreen />} />
            <Route path="/orders" element={<OrderListing />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (

    <Router>
      <InnerApp />
    </Router>
  );
}

export default App;